<template>
  <div class="row">
    <div class="col-md-12">
      <h4 class="title">Search by</h4>

    </div>
      <div class="col-md-12 card" style="margin:auto;margin-bottom:30px;">
        <div class="card-body row">

          <div class="col-md-2" style="margin-top:auto;margin-left:auto;">
            <fg-input>
              <el-select class="select-primary"
                         size="large"
                         placeholder="Single Select"
                         v-model="selected">
                <el-option v-if="role === 'agent' || role === 'commercial'" v-for="option in select.category"
                           class="select-primary"
                           :value="option.value"
                           :label="option.label"
                           :key="option.label">
                </el-option>
                <el-option v-if="role === 'supplier'" v-for="option in categorySupplier"
                           class="select-primary"
                           :value="option.value"
                           :label="option.label"
                           :key="option.label">
                </el-option>
              </el-select>
            </fg-input>
          </div>
          <div class="col-md-2" style="margin-top:auto;margin-left:auto;" v-if="role === 'agent'">
            <fg-input>
              <el-select class="select-primary"
                         size="large"
                         placeholder="Select a commercial"
                         v-model="selectedCom"
                         filterable >
                <el-option v-for="option in commercialList"
                           class="select-primary"
                           :value="option.login"
                           :label="option.login"
                           :key="option.login">
                </el-option>
              </el-select>
            </fg-input>
          </div>
          <div class="col-md-2" style="margin-top:auto;margin-left:auto;">
            <fg-input>
              <el-select class="select-primary"
                         size="large"
                         placeholder="Single Select"
                         v-model="selectedContractType">
                <el-option v-if="role === 'agent' || role === 'commercial'" v-for="option in contractTypes"
                           class="select-primary"
                           :value="option.value"
                           :label="option.label"
                           :key="option.label">
                </el-option>
                <el-option v-if="role === 'supplier'" v-for="option in categorySupplier"
                           class="select-primary"
                           :value="option.value"
                           :label="option.label"
                           :key="option.label">
                </el-option>
              </el-select>
            </fg-input>
          </div>
          <div class="col-md-2" style="margin-top:auto;margin-left:auto;" v-if="role === 'agent' || role === 'commercial'">
            <fg-input>
              <el-select class="select-primary"
                         size="large"
                         placeholder="Select a commercial"
                         v-model="selectedDateType"
                         filterable >
                <el-option v-for="option in dateType"
                           class="select-primary"
                           :value="option.value"
                           :label="option.label"
                           :key="option.value">
                </el-option>
              </el-select>
            </fg-input>
          </div>
          <div class="col-md-2" style="margin-top:10px;">
            <fg-input>
              <el-date-picker v-model="datePickerFromTemp"
                              type="date"
                              placeholder="From"
                              :picker-options="pickerOptions1">
              </el-date-picker>
            </fg-input>
          </div>
          <div class="col-md-2" style="margin-top:10px;">
            <fg-input>
              <el-date-picker v-model="datePickerToTemp"
                              type="date"
                              placeholder="To"
                              :picker-options="pickerOptions1">
              </el-date-picker>
            </fg-input>
          </div>
          <!--
          <div class="col-md-1" style="margin: auto;">
            <input type="text" placeholder="Contain" class="form-control primary" v-model="containFilter">
          </div>
          -->
          <div class="col-md-2" style="margin:auto;text-align:center; margin-top:20px;">
            <button type="button" class="btn btn-primary" style="margin: auto; text-align: center;" v-on:click="getContracts()">Search</button>
          </div>
        </div>
  </div>
    <div class="col-md-12 card" >
      <div class="card-header">
        <div class="category">Contracts</div>
      </div>
      <div class="card-body row">
        <div class="col-sm-6">
          <el-select
            class="select-default"
            v-model="pagination.perPage"
            placeholder="Per page">
            <el-option
              class="select-default"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="col-sm-4">
        <download-csv :data="tableData" :fields="fieldExport"><a><i class="nc-icon nc-cloud-download-93" style="font-size:25px; color: #6bd098; cursor: pointer; float:right"></i></a></download-csv>
      </div>
        <div class="col-sm-2">
          <div class="pull-right" style="float:right">
            <fg-input class="input-sm"
                      placeholder="Search"
                      v-model="searchQuery"
                      addon-right-icon="nc-icon nc-zoom-split">
            </fg-input>
          </div>
        </div>
        <div class="col-sm-12 mt-2">
          <el-table class="table-striped"
                    v-loading="loading"
                    :data="queriedData"
                    border
                    style="width: 100%; font-size:12px;">
            <el-table-column
                    class-name="action-buttons td-actions"
                    align="center"
                    label="Edit"
                    min-width="120">
              <template slot-scope="props">
                <p-button v-if="props.row.state === 'pending_sign'" type="info" size="sm" icon @click="handleExtendLink(props.$index, props.row)">
                  <i class="nc-icon nc-email-85"></i>
                </p-button>
                <p-button type="warning" size="sm" v-if="props.row.state === 'pending_sign'" icon @click="handleRemoveLink(props.$index, props.row)">
                  <i class="nc-icon nc-simple-remove"></i>
                </p-button>

                <p-button  type="info" size="sm" icon @click="handleView(props.$index, props.row)">
                  <i class="nc-icon nc-zoom-split"></i>
                </p-button>
                <p-button v-if="role === 'agent' && props.row.datagen && props.row.state != 'pending_sign'" type="danger" size="sm" icon @click="handleEdit(props.$index, props.row)">
                  <i class="fa fa-edit"></i>
                </p-button>
              </template>
            </el-table-column>


            <el-table-column
              label="sign date"
              width="120">
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.sign_date | formatDate }}</span>
              </template>
            </el-table-column>
            <el-table-column
                    label="validation date"
                    width="120">
              <template slot-scope="scope">
                <span style="margin-left: 10px" v-if="scope.row.validation_date">{{ scope.row.validation_date | formatDate }}</span>
              </template>
            </el-table-column>
            <el-table-column
                    class-name=""
                    align="center"
                    min-width="120"
                    label="Status">
              <template slot-scope="props">
                <span v-if="props.row.state === 'valide'">Pending supplier</span>
                <span v-if="props.row.state != 'valide'">{{props.row.state}}</span>
              </template>
            </el-table-column>
            <el-table-column
                              sortable
                              v-for="column in tableColumns"
                             :key="column.label"
                             :min-width="column.minWidth"
                             :prop="column.prop"
                             :label="column.label">
            </el-table-column>

            <el-table-column
                    class-name=""
                    align="center"
                    min-width="200"
                    label="Terminals">
              <template slot-scope="props">
                <span v-if="props.row.terminals[0]">{{props.row.terminals[0].supplier}}</span>

              </template>
            </el-table-column>

            <el-table-column
                class-name=""
                align="center"
                min-width="200"
                v-if="role === 'agent'"
                label="last_message">
              <template slot-scope="props">
                <span v-if="props.row.last_message">{{props.row.last_message.reason}}</span>

              </template>
            </el-table-column>


            <el-table-column
                class-name=""
                align="center"
                min-width="200"
                v-if="role === 'agent'"
                label="Remote sign link">
              <template slot-scope="props">
                <span v-if="props.row.signLink && props.row.state=='pending_sign'"><a :href="props.row.signLink" target=”_blank”>{{props.row.signLink}}</a></span>

              </template>
            </el-table-column>

          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
        </div>
        <div class="col-sm-6">
          <p-pagination class="pull-right"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total">
          </p-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {DatePicker, Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  export default{
    components: {
      PPagination,
      PSwitch,
      [DatePicker.name]: DatePicker,
    },
    computed: {
      pagedData () {
        return this.tableData.slice(this.from, this.to)
      },
      /***
       * Searches through table data and returns a paginated array.
       * Note that this should not be used for table with a lot of data as it might be slow!
       * Do the search and the pagination on the server and display the data retrieved from server instead.
       * @returns {computed.pagedData}
       */
      queriedData () {
        if (!this.searchQuery) {
          this.pagination.total = this.tableData.length;
          return this.pagedData
        }
        let result = this.tableData
          .filter((row) => {
            let isIncluded = false;
            for (let key of this.propsToSearch) {
              let rowValue
              if(row[key]) {
                rowValue = row[key].toString().toLowerCase()
                if(key.includes('.')) {
                  rowValue = row[key.split('.')[0]][key.split('.')[1]].toString()
                } else {
                  rowValue = row[key].toString().toLowerCase()
                }
              } else {
                rowValue = ''
              }

              if (rowValue.toLowerCase().includes && rowValue.includes(this.searchQuery.toLowerCase())) {
                isIncluded = true
              }
            }
            return isIncluded
          });
        this.pagination.total = result.length;
        return result.slice(this.from, this.to)
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total () {
        this.pagination.total = this.tableData.length;
        return this.tableData.length;
      }
    },
    data () {
      return {
        fieldExport: ['_id', 'vat', 'company_name', 'sign_date', 'validation_date', 'state', 'product','user', 'commercial', 'companySubName', 'companyAddressConcat', 'installationAddressConcat', 'last_message'],
        pickerOptions1: {
          shortcuts: [{
            text: 'Today',
            onClick (picker) {
              picker.$emit('pick', new Date())
            }
          }]
        },
        selectedContractType: '',
        contractTypes: [
          {value: '', label: "All"},
          {value: "GiftEdenred", label: "GiftEdenred"},
          {value: "MealSodexo", label: "MealSodexo"},
          {value: "MealEdenred", label: "MealEdenred"},
          {value: "EcoEdenred", label: "EcoEdenred"},
          {value: "EcoMonizze", label: "EcoMonizze"},
          {value: "EcoSodexo", label: "EcoSodexo"},
          {value: "Ems", label: "Ems"},
          {value: "MealMonizze", label: "MealMonizze"},
          {value: "GiftMonizze", label: "GiftMonizze"},
          {value: "Connect", label: "Connect"}
        ],
        selectedDateType: 'signature_date',
        dateType: [
          {value: "signature_date", label: "sign date"},
          {value: "validation_date", label: "validation date"},
          {value: "last_update", label: "last update"}
        ],
        datePickerFromTemp: '',
        datePickerToTemp: '',
        loading: false,
        selected: '',
        selectedBy: 'contract',
        selectedCom: 'All',
        containFilter: '',
        commercialList: [],
        categorySupplier: [{ value: '', label:'All'}, /*{ value: 'Correction Fournisseur', label:'Correction Fournisseur'},*/ { value: 'Validation Fournisseur', label:'Valide'}, { value: 'Refus Fournisseur', label:'Refus'}, { value: 'Valide', label:'En attente'}],
        select: {
          category: [{ value: '', label:'All'}, /*{ value: 'Correction Fournisseur', label:'Correction Fournisseur'},*/ { value: 'Refus', label:'Refus'}, { value: 'Validation Fournisseur', label:'Validation Fournisseur'}, { value: 'Attente Terminal', label:'Attente Terminal'}, { value: 'pending kb', label:'en attente kb'}, { value: 'Refus Fournisseur', label:'Refus Fournisseur'}, { value: 'Valide', label:'en attente fournisseur'}, { value: 'pending_sign', label: 'Attente signature'}],
          by: [{value: 'commercial', label: 'Commercial'}, {value: 'contract', label: 'Contract'}]
        },
        pagination: {
          perPage: 10,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery: '',
        propsToSearch: ['company_name', 'companySubName','companyAddressConcat', 'installationAddressConcat','contact.email', 'contact.phone_number', 'vat','product', 'sign_date', 'terminal.type', 'terminal.supplier', 'user'],
        tableColumns: [
          {
            prop: 'product',
            label: 'Product',
            minWidth: 150
          },
          {
            prop: 'company_name',
            label: 'Company official',
            minWidth: 200
          },
          {
            prop: 'installationAddress.name',
            label: 'Company',
            minWidth: 200
          },

          {
            prop: 'user',
            label: 'Commercial',
            minWidth: 150
          },
          {
            prop: 'vat',
            label: 'VAT',
            minWidth: 150
          }
          /*,
          {
            prop: 'terminal.supplier',
            label: 'Terminal supplier',
            minWidth: 150
          },

          {
            prop: 'companyAddressConcat',
            label: 'Address',
            minWidth: 300
          },
          {
            prop: 'installationAddress.name',
            label: 'POS name',
            minWidth: 200
          },
          {
            prop: 'installationAddressConcat',
            label: 'POS',
            minWidth: 300
          },
          {
            prop: 'contact.email',
            label: 'Email',
            minWidth: 250
          },
          {
            prop: 'contact.phone_number',
            label: 'Phone',
            minWidth: 150
          },
          {
            prop: 'terminal.type',
            label: 'Terminal type',
            minWidth: 150
          }

                 */

        ],
        tableData: [],
        role: localStorage.role
      }
    },
    mounted() {
      if(this.role === 'agent') {
        this.getCommercials(),
                this.selected = 'pending kb'
      } else if (this.role === 'supplier') {
        this.selected = 'Valide'
      }
      //this.datePickerFromTemp = new Date(new Date().getFullYear() + '-' + (new Date().getMonth()+1) + '-' + '01')
      this.getContracts()
    },
    methods: {
      handleExtendLink (index, row) {
        this.extendRemoteSign(row._id)
      },
      handleRemoveLink (index, row) {
        this.deleteRemoteSign(row._id)
      },
      handleEdit (index, row) {
        //this.$router.push({path: '/pages/contract/edit?id=' + row._id});
        let route = this.$router.resolve('/spe/contract/edit?id='+ row._id)
        window.open(route.href, '_blank');
        //window.open(route.href, '_blank');
        //this.$router.push('/pages/contract?id='+ row._id);
      },
      handleView (index, row) {
        //this.$router.push({path: '/pages/contract/view?id=' + row._id});

        let route = this.$router.resolve('/spv/contract/view?id='+ row._id)
        window.open(route.href, '_blank');
        //this.$router.('/sp/contract/view?id='+ row._id);
      },
      getContracts() {
        this.loading=true;
        let fromDate;
        let toDate;
        let com;
        if(this.datePickerFromTemp === '' || !this.datePickerFromTemp) {
          fromDate = new Date('2000-01-01')
        } else {
          fromDate = this.datePickerFromTemp
        }
        if(this.datePickerToTemp === '' || !this.datePickerToTemp) {
          toDate = new Date('2120-01-01')
        } else {
          let tempDateTo = new Date(this.datePickerToTemp)
          tempDateTo.setDate(tempDateTo.getDate() +1)
          tempDateTo= tempDateTo.toISOString()
          toDate = tempDateTo
        }
        if(this.selectedCom === 'All') {
          this.com = '';
        } else {
          this.com = this.selectedCom
        }
        this.$http({
          method: 'get',
          url: this.$apiUrl + '/contract/contracts',
          headers: {'Authorization': 'Bearer ' + localStorage.token},
          params: {by: 'contract',type : this.selected.toLowerCase(), commercial: this.com, contract_type: this.selectedContractType, filter: this.containFilter, from: fromDate, to: toDate, date_type: this.selectedDateType},
        }).then(response => (
          this.tableData = response.data.map(el => {
            el.companySubName = el.installationAddress.name
            el.companyAddressConcat = el.companyAddress.street + ' ' + el.companyAddress.street_number + ' ' + el.companyAddress.postal_code + ' ' +  el.companyAddress.locality
            el.installationAddressConcat = el.installationAddress.street + ' ' + el.installationAddress.street_number + ' ' + el.installationAddress.postal_code + ' ' +  el.installationAddress.locality
            el.last_message = el.history[el.history.length - 1]

            if (el.externalLink) {
              if (el.externalLink.expire && el.externalLink.uuid) {
                if (new Date(el.externalLink.expire).getTime() != 0 && new Date(el.externalLink.expire).getTime()) {
                  el.signLink = "https://e-contracts.eu/#/rs/rspthk/rs?token=" + el.externalLink.uuid + "&timest=" + new Date(el.externalLink.expire).getTime()
                } else {
                  el.signLink = "N/A"
                }
              } else {
                el.signLink = "N/A"
              }
            } else {
              el.signLink = "N/A"
            }
            return el
          }),
          this.loading= false
        )).catch(err => {
          this.$notify({
            message: 'Impossible to retrieve data',
            type: 'danger',
            horizontalAlign: 'center',
            verticalAlign: 'top'
          })
        })
      },
      deleteRemoteSign(id) {
        this.$http({
          method: 'post',
          url: this.$apiUrl + '/contract/removeRemoteSign',
          headers: {'Authorization': 'Bearer ' + localStorage.token},
          data: {id: id}
        }).then(response => (
            this.getContracts()
        )).catch(err => {
          this.$notify({
            message: 'Impossible to retrieve data',
            type: 'danger',
            horizontalAlign: 'center',
            verticalAlign: 'top'
          })
        })
      },
      extendRemoteSign(id) {
        this.$http({
          method: 'post',
          url: this.$apiUrl + '/contract/renewLink',
          headers: {'Authorization': 'Bearer ' + localStorage.token},
          data: {id: id}
        }).then(response => (
            this.getContracts(),
                alert('48h added')
        )).catch(err => {
          this.$notify({
            message: 'Impossible to retrieve data',
            type: 'danger',
            horizontalAlign: 'center',
            verticalAlign: 'top'
          })
        })
      },
      getCommercials() {
        this.$http({
          method: 'get',
          url: this.$apiUrl + '/commercial/commercials',
          headers: {'Authorization': 'Bearer ' + localStorage.token}
        }).then(response => (
          this.commercialList = response.data,
          this.commercialList.unshift({login: "All"})
        )).catch(err => {
          this.$notify({
            message: 'Impossible to retrieve data',
            type: 'danger',
            horizontalAlign: 'center',
            verticalAlign: 'top'
          })
        })
      },
    }
  }
</script>
<style lang="scss">

  .el-table .td-actions{
    button.btn {
      margin-right: 5px;
    }
  }
  .el-table th {
    font-size: 10px !important;
    padding: 2px 2px !important;
  }
  .el-table td {
    padding: 3px 2px !important;
  }
</style>


